import React from "react";
import styled, { keyframes } from "styled-components";

const Container = styled.div`
  height: 75vh;
  width: 100%;
  display: flex;
  padding-top: 23vh;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all ease 1s;
  background-color: #dddddd;
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }`;

const Rotate = styled.span`
  display: inline-block;
  animation: ${rotate} 2s linear infinite;
  padding: 2rem 1rem;
  margin-top: 10%;
  font-size: 4rem;
`;

const TXT = styled.h3`
  padding-bottom: 38vh;
  @media only screen and (max-width: 750px) {
    font-size: 15px;
  }
`;

const Loading = () => {
  return (
    <Container>
      <Rotate>
        <span role="img" aria-label="Loading">
          ⭐
        </span>
      </Rotate>
      <TXT>평점 좋은 상품들만 찾고 있어요 :)</TXT>
    </Container>
  );
};

export default Loading;
